import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-900 text-gray-300 py-12 border-t border-white/10" data-id="element-28">
      <div className="max-w-6xl mx-auto px-4" data-id="element-29">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12" data-id="element-30">
          <div className="font-heading font-bold text-2xl text-white tracking-tighter" data-id="element-31">
            IMPERIO <span className="text-gold" data-id="element-32">AMERICANO</span>
          </div>

          <div className="flex flex-wrap justify-center gap-6 font-heading text-sm" data-id="element-33">
            <a href="#" className="hover:text-gold transition-colors" data-id="element-34">
              Inicio
            </a>
            <a href="#pricing" className="hover:text-gold transition-colors" data-id="element-35">
              Programa
            </a>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-36">
              Testimonios
            </a>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-37">
              FAQ
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-6 text-sm" data-id="element-38">
          <p data-id="element-39">© 2026 Imperio Americano. Todos los derechos reservados.</p>

          <div className="flex items-center gap-2 bg-white/5 px-4 py-2 rounded-full border border-white/10" data-id="element-40">
            <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-41" />
            <span data-id="element-42">Secure Checkout via Stripe & PayPal</span>
          </div>

          <div className="flex gap-4" data-id="element-43">
            <a href="#" className="hover:text-white transition-colors" data-id="element-44">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-45">
              Términos
            </a>
          </div>
        </div>

        <div className="mt-12 text-xs text-gray-500 text-center max-w-4xl mx-auto leading-relaxed" data-id="element-46">
          Descargo de responsabilidad: Los resultados mencionados en esta página
          no son típicos y dependen del esfuerzo individual, la situación
          financiera y las condiciones del mercado. Imperio Americano es un
          programa educativo y no ofrece asesoría legal, financiera o contable
          personalizada. Consulte siempre con un CPA o abogado licenciado en su
          estado antes de tomar decisiones financieras importantes.
        </div>
      </div>
    </footer>;
}